import dayjs from 'dayjs';
import { Model } from './model';
import { TransformStringToDayJS } from './utils';

export class Event extends Model {
  name: string;

  data: Record<string, any>;

  @TransformStringToDayJS()
  completed_at: dayjs.Dayjs | null;

  event_id: string | null;

  entity_type: string | null;

  @TransformStringToDayJS()
  timestamp: dayjs.Dayjs | null;
}
